import { render, staticRenderFns } from "./accountJournalList.vue?vue&type=template&id=955d472c"
import script from "./accountJournalList.vue?vue&type=script&lang=js"
export * from "./accountJournalList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports